import lodashGet from 'lodash/get';

/**
 * Read a value at a dotted path — the reader every `@mfw/forms` component uses
 * against React Hook Form state (`get(defaultValues, name)`).
 *
 * Backed by lodash rather than `deep-get-set`. That package ships no type
 * declarations and `@types/deep-get-set` does not exist on npm, so the import
 * had to be silenced with `@ts-ignore` — which left `get` returning an implicit
 * `any` to every call site. lodash is already a dependency here, is fully
 * typed, and accepts the same dotted paths (plus bracket notation).
 *
 * The companion `set` is gone with it: nothing in the monorepo called it.
 */
export function get<TResult = unknown>(
  obj?: unknown,
  key?: string,
): TResult | undefined {
  if (!key) return undefined;
  return lodashGet(obj, key) as TResult | undefined;
}
